<template>
  <div class="wrapper">
    <hooper :settings="hooperSettings" class="hopper w-100">
      <slide class="section header-filter page-header" :style="franceStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                FRANCE
              </h1>
              <h4></h4>
              <br />
              <md-button @click="detail('france')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="canadaStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                CANADA
              </h1>
              <h4 class="desc"></h4>
              <br />
              <md-button @click="detail('canada')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="usaStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                USA
              </h1>
              <h4 class="desc"></h4>
              <br />
              <md-button @click="detail('usa')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="chineStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                CHINE
              </h1>
              <h4 class="desc"></h4>
              <br />
              <md-button @click="detail('chine')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="turkieStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                TURQUIE
              </h1>
              <h4 class="desc"></h4>
              <br />
              <md-button @click="detail('turquie')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="japonStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                JAPON
              </h1>
              <h4 class="desc"></h4>
              <br />
              <md-button @click="detail('japon')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="chypreStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                CHYPRE DU NORD
              </h1>
              <h4 class="desc"></h4>
              <br />
              <md-button @click="detail('chypre')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="beninStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                BRESIL
              </h1>
              <h4 class="desc"></h4>
              <br />
              <md-button @click="detail('bresil')" class="md-success md-l">
                Avantages
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
export default {
  bodyClass: "voyage",
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    canada: {
      type: String,
      default: require("@/assets/img/canadastyle.jpg")
    },
    france: {
      type: String,
      default: require("@/assets/img/paris.jpg")
    },
    usa: {
      type: String,
      default: require("@/assets/img/usastyle.jpeg")
    },
    chine: {
      type: String,
      default: require("@/assets/img/chinestyle.jpeg")
    },
    benin: {
      type: String,
      default: require("@/assets/img/beninstyle.jpeg")
    },
    turkie: {
      type: String,
      default: require("@/assets/img/turquistyle.jpeg")
    },
    japon: {
      type: String,
      default: require("@/assets/img/japonstyle.jpeg")
    },
    chypre: {
      type: String,
      default: require("@/assets/img/chyprestyle.jpeg")
    }
  },
  data() {
    return {
      hooperSettings: {
        infiniteScroll: true,
        centerMode: false,
        autoPlay: true,
        playSpeed: 5000,
        breakpoints: {
          2400: {
            itemsToShow: 1
          },
          1800: {
            itemsToShow: 1
          },
          1500: {
            itemsToShow: 1
          },
          1100: {
            itemsToShow: 1
          },
          1024: {
            itemsToShow: 1
          },
          630: {
            itemsToShow: 1
          },
          504: {
            itemsToShow: 1
          },
          330: {
            itemsToShow: 1
          },
          0: {
            itemsToShow: 1
          }
        }
      }
    };
  },
  methods: {
    detail(name) {
      this.$emit('oga', name)
    }
  },
  computed: {
    franceStyle() {
      return {
        backgroundImage: `url(${this.france})`
      };
    },

    canadaStyle() {
      return {
        backgroundImage: `url(${this.canada})`
      };
    },

    usaStyle() {
      return {
        backgroundImage: `url(${this.usa})`
      };
    },
    chineStyle() {
      return {
        backgroundImage: `url(${this.chine})`
      };
    },
    japonStyle() {
      return {
        backgroundImage: `url(${this.japon})`
      };
    },
    beninStyle() {
      return {
        backgroundImage: `url(${this.benin})`
      };
    },
    turkieStyle() {
      return {
        backgroundImage: `url(${this.turkie})`
      };
    },
    chypreStyle() {
      return {
        backgroundImage: `url(${this.chypre})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
